import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Pagination from "react-js-pagination";
import Select from "react-select";
import downArrow from "../../../assets/svg/downarrow.svg";
import upArrow from "../../../assets/svg/uparrow.svg";
import FileSaver from "file-saver";
import moment from "moment";
import dateIcon from "../../../assets/svg/calendar-inside.svg";
import infoBlack from "../../../assets/svg/infoBlack.svg";
import search from "../../../assets/svg/search.svg";
import Filter from "../../../assets/svg/filter.svg";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Icon from "@material-ui/core/Icon";
import DateFnsUtils from "@date-io/date-fns";
import calender from "../../../assets/svg/calender.svg";
import Autocomplete from "react-autocomplete";
import file from "../../../assets/svg/File.svg";
import arrowright from "../../../assets/svg/arrow-right.svg";
import arrowleft from "../../../assets/svg/arrow-left.svg";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import UserRole from "../../../helpers/role";
import { useSelector } from "react-redux";
import FavoriteIcon from "../../../assets/svg/FavoriteBig.svg";
import AudioPopup from "../layout/AudioPop";
import VideoPop from "../layout/VideoPop";
import { useLocation } from "react-router-dom";
import formats from "../../../helpers/MediaFormats";
import RemoveFavoriteIcon from "../../../assets/svg/removefavorites.svg";
import axios from "axios";
import babyRun from "../../../assets/videos/baby run.mp4";
import FileIcon from "../documents/folder/FileIcon";
import url from "../../../assets/svg/url.svg";
import music from "../../../assets/audio/sampleAudio.wav";
import samplePpt from "../../../assets/doc/Sample_Slides.pptx";
import sampleDoc from "../../../assets/doc/Sample_pdf.pdf";
import API from "../../../helpers/endpointService";
import documentIcon from "../../../assets/svg/docx.svg";
import DownloadIcon from "../../../assets/svg/downloadIcon.svg";
import PropertiesIcon from "../../../assets/svg/properties.svg";
import PPTIcon from "../../../assets/svg/ppt.svg";
import VersionIcon from "../../../assets/svg/versionlog.svg";
import NotesIcon from "../../../assets/svg/notesIcon.svg";
import VideoIcon from "../../../assets/svg/videofile.svg";
import AudioIcon from "../../../assets/svg/audioIcon.svg";
import DownArrowIcon from "../../../assets/svg/downarrow.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DateIcon from "../../../assets/svg/date.svg";
import AssignIcon from "../../../assets/svg/assignedtoIcon.svg";
import SubCategoryIcon from "../../../assets/svg/smallcategory.svg";
import SearchFileIcon from "../../../assets/svg/Filesearch.svg";
import CrossIcon from "../../../assets/svg/crossIcon.svg";
import NewPropertiesIcon from "../../../assets/svg/propertiesicon.svg";
import UpArrowIcon from "../../../assets/svg/uparrow.svg";
import LeftArrowIcon from "../../../assets/svg/LeftArrow.svg";
import RightArrowIcon from "../../../assets/svg/RightArrow.svg";
import ReactPaginate from "react-paginate";
import { PulseLoader } from "react-spinners";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import $ from "jquery";
import { logoutFunction } from "../../custom/commonFunction";
import PasswordLoginModal from "../../custom/commonPasswordLogin";

var SelectedValueSearch = false;

const paginglist = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
];
const paginglistDefault = [{ label: "20", value: 20 }];

var closeNewSearch = false;

class Favourites extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "publishedDate",
      currentUser: "",
      isFormValid: true,
      height: window.innerHeight,
      isMobile: false,
      isFavoriteFailed: false,
      isFavoriteLoader: false,
      isSmallMobile: false,
      isCancelMobile: false,
      isRadioMobile: false,
      singleFileName: "",
      versionLogList: [],
      favouritesList: undefined,
      favouriteArryList: [],
      favoritesDocumentList: [],
      favouritesFilesList: [],
      isPlayVideo: false,
      isPlayAudio: false,
      openauthorList: false,
      opencategory1List: false,
      opencategory2List: false,
      videoSrc: "",
      totalCount: 0,
      audioSrc: "",
      favouritePropertiesList: {
        id: 0,
        documentName: "",
        revisedDocumentId: 0,
        documentNo: "",
        version: 0,
        category1Id: 0,
        category2Id: 0,
        category1Name: "",
        category2Name: "",
        authorId: 0,
        authorName: "",
        documentDate: "",
        publishedDate: "",
        documentStatus: "",
        approvalStatus: "",
        reviewDate: "",
        remarks: "",
      },
      favouriteCount: 0,
      searchAuthorList: [],
      searchCategory1List: [],
      searchCategory2List: [],
      fileTypes: [],
      userRole: "",
      currentPage: 1,
      perPage: 20,
      userId: 0,
      searchInputData: {
        docNo: "",
        docName: "",
        category1: null,
        category1Id: 0,
        category2: null,
        category2Id: 0,
        author: null,
        authorId: 0,
        fileType: "",
        fileName: "",
        status: "",
        expiryDate: "",
      },
      isLoginModal: false,
      openDocument: {},
      openDocumentType: "",
    };
  }

  componentDidMount() {
    let _this = this;
    let Role = localStorage.getItem("Role");
    let user = localStorage.getItem("UserId");
    this.state.userId = user;
    this.state.currentUser = Role;
    this.setState({}, () => {
      this.GetFavouritesList();
      this.GetAdminList();
      this.GetCategory1();
      this.GetFileTypesList();
    });
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }
  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 500) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }

    if (window.innerWidth < 350) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 315) {
      this.state.isCancelMobile = true;
    } else {
      this.state.isCancelMobile = false;
    }
    this.state.height = window.innerHeight;
    this.setState({});
  };

  GetFavouritesList = () => {
    const { currentPage, perPage, userId } = this.state;
    let order = this.state.order === "asc" ? true : false;
    let apiUrl = `${API.GET_ALL_FAVORITES}?userId=${userId}&sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    this.setState({ isFavoriteLoader: true, isFavoriteFailed: false });
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        pageNumber: parseInt(currentPage),
        pagesize: parseInt(perPage),
        documentId: 0,
        documentName: this.state.searchInputData.docName
          ? this.state.searchInputData.docName
          : null,
        documentNo: this.state.searchInputData.docNo
          ? this.state.searchInputData.docNo
          : null,
        category1Id: this.state.searchInputData.category1?.value || 0,
        category1Name: this.state.searchInputData.category1?.label || null,
        category2Id: this.state.searchInputData.category2?.value || 0,
        category2Name: this.state.searchInputData.category2?.label || null,
        documentStatus: this.state.searchInputData.documentStatus || null,
        approvalStatus: this.state.searchInputData.approvalStatus || null,
        fileId: 0,
        fileName: this.state.searchInputData.fileName
          ? this.state.searchInputData.fileName
          : null,
        fileType: this.state.searchInputData.fileType
          ? this.state.searchInputData.fileType
          : null,
        authorId: this.state.searchInputData.author?.value || 0,
        authorName: this.state.searchInputData.author?.label || null,
        fromDate: null,
        toDate: null,
        publishedDate: this.state.searchInputData.expiryDate
          ? moment(this.state.searchInputData.expiryDate).format("YYYY-MM-DD")
          : null,
        expiryDate: null,
        requestedDate: null,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.favouritesList = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.state.favouriteCount = res.data.totalCount;
          this.setState({ isFavoriteLoader: false, isFavoriteFailed: false });
        }
      })
      .catch((error) => {
        this.setState({ isFavoriteLoader: false, isFavoriteFailed: false });
        logoutFunction(error?.response?.status);
      });
  };

  find = (e) => {
    this.setState({ isFavoriteLoader: true, isFavoriteFailed: false });
    this.state.perPage = e.value;
    const selectedPage = 1;
    this.state.currentPage = selectedPage;
    this.setState({}, () => {
      this.GetFavouritesList();
    });
  };
  handlePageChange = (pageNumber) => {
    this.state.currentPage = pageNumber;
    this.setState({}, () => {});
    this.GetFavouritesList();
  };
  navigateDocuments = (path) => {
    const { navigate } = this.props;
    navigate(path);
  };
  handleOpenFavouriteProperties = () => {
    this.setState({ isFavoriteLoader: true, isFavoriteFailed: false });
    let SelectedId = this.state.favoritesDocumentList;
    let Id = SelectedId.toString();
    let apiUrl = `${API.GET_PROPERTIES}?docId=${parseInt(Id)}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.favouritePropertiesList = res.data;
          this.setState({}, () => {
            this.GetVersionLogList(this.state.favouritePropertiesList.id);
          });
        }
      })
      .catch((error) => {
        this.setState({ isFavoriteLoader: false, isFavoriteFailed: false });
        logoutFunction(error?.response?.status);
      });
  };
  GetVersionLogList = () => {
    var id = this.state.favouritePropertiesList.id;
    let apiUrl = `${API.GET_VERSION_LOG}?docId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.versionLogList = res.data;
          this.setState({}, () => {
            let myOffcanvas = new window.bootstrap.Offcanvas(
              document.getElementById("DetailsScreen")
            );
            myOffcanvas.show();
            $("body").addClass("scrollhide");
            const viewbar = document.getElementById("viewbar");
            viewbar?.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          });
          this.setState({ isFavoriteLoader: false, isFavoriteFailed: false });
        }
      })
      .catch((error) => {
        this.setState({ isFavoriteLoader: false, isFavoriteFailed: false });
        logoutFunction(error?.response?.status);
      });
  };

  removeFavouriteMessage = (Id) => {
    this.setState({ isFavoriteLoader: true, isFavoriteFailed: false });
    const { userId, favouriteArryList } = this.state;
    let apiUrl = `${API.DELETE_FAVORITES}?userId=${userId}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: favouriteArryList,
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Removed successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          this.state.favouriteArryList = [];
          this.state.favoritesDocumentList = [];
          this.state.favouritesFilesList = [];
          this.setState({});
          this.GetFavouritesList();
        }
      })
      .catch((error) => {
        this.setState({ isFavoriteLoader: false, isFavoriteFailed: false });
        logoutFunction(error?.response?.status);
      });
  };
  downloadMessage = () => {
    const { favouritesFilesList, favouritesList, singleFileName } = this.state;
    this.setState({ isFavoriteLoader: true, isFavoriteFailed: false });
    let DownloadFiles = [];
    if (this.state.favouritesFilesList?.length !== 0) {
      if (this.state.favouritesFilesList?.length > 1) {
        favouritesList?.map((j, ind) => {
          if (
            favouritesFilesList.filter(
              (i) => i == j.fileId && j.fileType !== "url"
            )?.length !== 0
          ) {
            DownloadFiles.push(j.fileId);
          }
        });
        var ids = DownloadFiles;
        if (ids?.length !== 0) {
          let apiUrl = `${API.MULTIPLE_FILES_DOWNLOAD}`;
          axios({
            method: "POST",
            url: apiUrl,
            data: ids,
            responseType: "blob",
          })
            .then((res) => {
              if (res.status === 200) {
                let blob = "";
                blob = new Blob([res.data], { type: res.data.type });
                FileSaver.saveAs(blob);
                toast.success("Downloaded successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
                this.state.favouriteArryList = [];
                this.state.favoritesDocumentList = [];
                this.state.favouritesFilesList = [];
                this.setState({
                  isFavoriteLoader: false,
                  isFavoriteFailed: false,
                });
                this.GetFavouritesList();
              }
            })
            .catch((error) => {
              this.setState({
                isFavoriteLoader: false,
                isFavoriteFailed: false,
              });
              logoutFunction(error?.response?.status);
            });
        }
      } else {
        if (
          favouritesList &&
          favouritesList.filter(
            (i) => i.fileId == singleFileName && i.fileType !== "url"
          )?.length !== 0
        ) {
          DownloadFiles.push(singleFileName);
        }
        var DisplayFileName = favouritesList.filter(
          (i) => i.fileId == singleFileName && i.fileType !== "url"
        );
        var ids = DownloadFiles;
        if (ids?.length !== 0) {
          let apiUrl1 = `${API.SINGLE_FILE_DOWNLOAD}?fileId=${singleFileName}`;
          axios
            .get(apiUrl1, { responseType: "blob" })
            .then((response) => {
              if (response?.status === 200) {
                let blob = "";
                blob = new Blob([response.data], { type: response.data.type });
                FileSaver.saveAs(blob, DisplayFileName[0].fileName);
                toast.success("Downloaded successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
                this.state.favouriteArryList = [];
                this.state.favoritesDocumentList = [];
                this.state.favouritesFilesList = [];
                this.state.singleFileName = "";
                this.setState({
                  isFavoriteLoader: false,
                  isFavoriteFailed: false,
                });
                this.GetFavouritesList();
              }
            })
            .catch((error) => {
              this.setState({
                isFavoriteLoader: false,
                isFavoriteFailed: false,
              });
              logoutFunction(error?.response?.status);
            });
        } else {
          this.setState({ isFavoriteLoader: false, isFavoriteFailed: false });
          toast.error("This file format can't be dowload", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
        }
      }
    }
  };
  handleFileOpen = (id, type) => {
    if (id) {
      let fileUrl = null;
      const fetchFileUrl = async () => {
        this.setState({ isFavoriteLoader: true, isFavoriteFailed: false });
        let fileSrcUrl = `${API.GET_FILES_URL}?fileId=${id}`;
        await axios
          .get(fileSrcUrl)
          .then((response) => {
            if (response?.status === 200) {
              fileUrl = response.data;
              if (fileUrl) {
                const fileType =
                  type === "url" ? type : fileUrl.split(".").pop();
                const supportedFormats = Object.values(formats).flat();

                if (supportedFormats.includes(fileType)) {
                  const findKeyByValue = (value, obj) => {
                    for (let key in obj) {
                      if (obj[key].includes(value)) {
                        return key;
                      }
                    }
                    return null;
                  };

                  const fileTypeKey = findKeyByValue(fileType, formats);
                  this.setState({
                    isFavoriteLoader: false,
                    isFavoriteFailed: false,
                  });
                  if (fileTypeKey) {
                    switch (fileTypeKey) {
                      case "video":
                        this.setState({ isPlayVideo: true, videoSrc: fileUrl });
                        break;
                      case "audio":
                        this.setState({ isPlayAudio: true, audioSrc: fileUrl });
                        break;
                      case "word":
                      case "pdf":
                      case "ppt":
                      case "zip":
                      case "image":
                      case "url":
                      case "xlsx":
                        window.open(fileUrl);
                        break;
                      default:
                        console.error(`Unsupported file type: ${fileType}`);
                    }
                    return;
                  } else {
                    console.error(`Unsupported file type: ${fileType}`);
                  }
                } else {
                  console.error(`Unsupported file type: ${fileType}`);
                }

                this.setState({
                  isFavoriteLoader: false,
                  isFavoriteFailed: false,
                });
              }
            }
          })
          .catch((error) => {
            this.setState({ isFavoriteLoader: false, isFavoriteFailed: false });
            logoutFunction(error?.response?.status);
          });
      };
      fetchFileUrl();
    }
  };
  handleCloseModal = () => {
    this.state.isPlayAudio = false;
    this.state.isPlayVideo = false;
    this.setState({});
  };
  handleCheckbox = (x, fileId, docId) => {
    const { favouriteArryList, favoritesDocumentList, favouritesFilesList } =
      this.state;
    if (favouriteArryList?.length == 0) {
      favouriteArryList.push(x);
      this.state.singleFileName = fileId;
    } else {
      if (
        favouriteArryList &&
        favouriteArryList.filter((i) => i == x)?.length == 1
      ) {
        favouriteArryList?.map((i, ind) =>
          i == x ? favouriteArryList.splice(ind, 1) : ""
        );
      } else {
        favouriteArryList.push(x);
      }
    }
    if (favoritesDocumentList?.length == 0) {
      favoritesDocumentList.push(docId);
    } else {
      if (
        favoritesDocumentList &&
        favoritesDocumentList.filter((i) => i == docId)?.length == 1
      ) {
        favoritesDocumentList?.map((i, ind) =>
          i == docId ? favoritesDocumentList.splice(ind, 1) : ""
        );
      } else {
        favoritesDocumentList.push(docId);
      }
    }
    if (favouritesFilesList?.length == 0) {
      favouritesFilesList.push(fileId);
    } else {
      if (
        favouritesFilesList &&
        favouritesFilesList.filter((i) => i == fileId)?.length == 1
      ) {
        favouritesFilesList?.map((i, ind) =>
          i == fileId ? favouritesFilesList.splice(ind, 1) : ""
        );
      } else {
        favouritesFilesList.push(fileId);
      }
    }
    this.setState({});
  };
  handleChangeChecked = (x, fileId, docId) => {
    const {
      favouriteArryList,
      singleFileName,
      favoritesDocumentList,
      favouritesFilesList,
    } = this.state;
    if (favouriteArryList?.length == 0) {
      favouriteArryList.push(x);
      this.state.singleFileName = fileId;
    } else {
      if (
        favouriteArryList &&
        favouriteArryList.filter((i) => i == x)?.length == 1
      ) {
        favouriteArryList?.map((i, ind) =>
          i == x ? favouriteArryList.splice(ind, 1) : ""
        );
      } else {
        favouriteArryList.push(x);
      }
    }
    if (favoritesDocumentList?.length == 0) {
      favoritesDocumentList.push(docId);
    } else {
      if (
        favoritesDocumentList &&
        favoritesDocumentList.filter((i) => i == docId)?.length == 1
      ) {
        favoritesDocumentList?.map((i, ind) =>
          i == docId ? favoritesDocumentList.splice(ind, 1) : ""
        );
      } else {
        favoritesDocumentList.push(docId);
      }
    }
    if (favouritesFilesList?.length == 0) {
      favouritesFilesList.push(fileId);
    } else {
      if (
        favouritesFilesList &&
        favouritesFilesList.filter((i) => i == fileId)?.length == 1
      ) {
        favouritesFilesList?.map((i, ind) =>
          i == fileId ? favouritesFilesList.splice(ind, 1) : ""
        );
      } else {
        favouritesFilesList.push(fileId);
      }
    }
    this.setState({});
  };
  handleCheckboxTop = () => {
    let data = [];
    let data1 = [];
    let data2 = [];
    if (
      this.state.favouriteArryList?.length !=
        this.state.favouritesList?.length &&
      this.state.favouriteArryList?.length > 0 &&
      this.state.favouritesList?.length > 0
    ) {
      this.state.favouritesList?.map((r) => data.push(r.id));
    }
    if (
      this.state.favouriteArryList?.length == 0 &&
      this.state.favouritesList?.length > 0
    ) {
      this.state.favouritesList?.map((r) => data.push(r.id));
    }
    if (
      this.state.favouriteArryList?.length ==
        this.state.favouritesList?.length &&
      this.state.favouritesList?.length > 0
    ) {
      data = [];
    }
    this.state.favouriteArryList = data;
    if (
      this.state.favoritesDocumentList?.length !=
        this.state.favouritesList?.length &&
      this.state.favoritesDocumentList?.length > 0 &&
      this.state.favouritesList?.length > 0
    ) {
      this.state.favouritesList?.map((r) => data1.push(r.documentId));
    }
    if (
      this.state.favoritesDocumentList?.length == 0 &&
      this.state.favouritesList?.length > 0
    ) {
      this.state.favouritesList?.map((r) => data1.push(r.documentId));
    }

    if (
      this.state.favoritesDocumentList?.length ==
        this.state.favouritesList.length &&
      this.state.favouritesList.length > 0
    ) {
      data1 = [];
    }
    this.state.favoritesDocumentList = data1;
    if (
      this.state.favouritesFilesList?.length !=
        this.state.favouritesList?.length &&
      this.state.favouritesFilesList?.length > 0 &&
      this.state.favouritesList?.length > 0
    ) {
      this.state.favouritesList?.map((r) => data2.push(r.fileId));
    }
    if (
      this.state.favouritesFilesList?.length == 0 &&
      this.state.favouritesList?.length > 0
    ) {
      this.state.favouritesList?.map((r) => data2.push(r.fileId));
    }

    if (
      this.state.favouritesFilesList?.length ==
        this.state.favouritesList?.length &&
      this.state.favouritesList?.length > 0
    ) {
      data2 = [];
    }
    this.state.favouritesFilesList = data2;
    this.setState({});
  };
  ClearArrayList = () => {
    this.state.favouriteArryList = [];
    this.state.favoritesDocumentList = [];
    this.state.favouritesFilesList = [];
    this.setState({});
    $("#DetailsScreen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
  };

  sortTable = (name) => {
    if (this.state.favouritesList?.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      this.state.currentPage = 1;
      this.setState({}, () => {
        this.GetFavouritesList();
      });
    }
  };

  /*   sortTable = (name) => {
      let sortData =this.state.favouritesList; 
      if(sortData?.length !==0 ){
       this.state.sortBy=name;
      this.setState({})
        if(this.state.sortBy === name) {
        if(this.state.order === "asc"){ 
           var ordernew = "desc"
           this.state.order=ordernew;
           this.setState({})
          }
          else { 
            var ordernew = "asc"
            this.state.order=ordernew;
            this.setState({})
          }
      
        }
      sortData.sort((a, b) => {
        let valueA = a[name];
        let valueB = b[name];
        if (name === "assignedDate" || name === "publishedDate"||name==="reviewDate"||name==="requestedDate") {
            let dateA = new Date(a[name]); 
            let dateB = new Date(b[name]);
        
            if (this.state.order === 'asc') {
              return dateA.getTime() - dateB.getTime();
            } else {
              return dateB.getTime() - dateA.getTime();
            }
          }
            else if (typeof valueA === 'number' && typeof valueB === 'number') {
            if (this.state.order === 'asc') {
              return valueA - valueB;
            } else {
              return valueB - valueA;
           }
      
          } else {
              if (this.state.order === 'asc') {
                return (valueA ??" ").localeCompare(valueB? valueB:"");
            } else {
              return (valueB ??" ").localeCompare(valueA? valueA:"");
            }
            }
        });
        this.state.favouritesList=sortData;
        this.setState({}) 
      }
      }; */
  /* Search functionality */

  GetAdminList = () => {
    let apiUrl = `${API.GET_ALL_USERS}?includeAdmin=true`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.searchAuthorList = res.data.map((res) => {
          return {
            value: res.id,
            label: res.userName,
          };
        });
        this.setState({});
      }
    });
  };
  GetFileTypesList = () => {
    let apiUrl = `${API.GET_FILE_TYPE}`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.fileTypes = res.data;
        this.setState({});
      }
    });
  };
  GetCategory1 = () => {
    let apiUrl = `${API.GET_CATAGORY_DROPDOWN}?type=category1&isLedger=false`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.searchCategory1List = res.data?.map((res) => {
          return {
            value: res.categoryId,
            label: res.categoryName,
          };
        });
        this.setState({});
      }
    });
  };
  GetCategory2 = (id) => {
    const { currentPage, perPage, userId } = this.state;
    let data = {
      pageNumber: parseInt(currentPage),
      pagesize: parseInt(perPage),
    };

    let apiUrl = `${API.GET_CATAGORY2}?category1Id=${id}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    }).then((res) => {
      if (res.status === 200) {
        this.state.searchCategory2List = res.data.values?.map((res) => {
          return {
            label: res.category2Name,
            value: res.category2Id,
          };
        });
        this.setState({});
      }
    });
  };
  handleChange = (e, field) => {
    if (field === "expiryDate") {
      const inputDate = e;
      this.state.searchInputData["expiryDate"] = inputDate;
      this.setState({}, () => {});
    } else {
      this.state.searchInputData[field] = e.target.value;
      this.setState({}, () => {});
    }
  };

  handleSearchSelectChange = (value, field) => {
    SelectedValueSearch = true;
    if (field === "category1") {
      this.state.searchInputData[field] = value;
      this.state.searchInputData["category2"] = null;
      this.setState({}, () => {
        if (value?.value) {
          this.GetCategory2(value.value);
        }
      });
    } else {
      this.state.searchInputData[field] = value;
    }
  };
  handleSearchInputChange = (e, field, fieldId) => {
    SelectedValueSearch = false;
    this.state.searchInputData[field] = e.target.value;
    this.state.searchInputData[fieldId] = 0;
    this.setState({}, () => {});
  };

  OpenPendingSearch = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("pendingSearchScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    const viewbar = document.getElementById("viewbar8");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  clearSearch = () => {
    this.state.searchInputData = {
      docNo: "",
      docName: "",
      category1: "",
      category1Id: 0,
      category2: "",
      category2Id: 0,
      author: "",
      authorId: 0,
      fileName: "",
      fileType: "",
      documentStatus: "",
      expiryDate: "",
    };

    closeNewSearch = true;
    this.submitSearch();
  };
  closeSearch = () => {
    // $("#pendingSearchScreen").removeClass("show");
    document.getElementById("closeSearchButton").click();
    $("body").removeClass("scrollhide");
  };
  validatesubmitSearch = () => {
    const inputs = document.querySelectorAll(".my-input-class[required]");
    const filledInputs = Array.from(inputs).filter(
      (input) => input.value !== ""
    );
    const isInputValid = filledInputs?.length > 0;

    var isDateInput = false;
    if (this.state.searchInputData.expiryDate === "") {
      isDateInput = false;
    } else {
      isDateInput = true;
    }
    var category1Input = this.state.searchInputData.category1!=="" &&  this.state.searchInputData.category1!==null ? true : false;
    var category2Input = this.state.searchInputData.category2!=="" && this.state.searchInputData.category2!==null ? true : false;
    var authorInput = this.state.searchInputData.author!=="" && this.state.searchInputData.author!==null ? true : false;
    // const category1Empty =
    //   !this.state.searchInputData.category1 ||
    //   this.state.searchInputData.category1 === null;
    // const category2Empty =
    //   !!this.state.searchInputData.category2 ||
    //   this.state.searchInputData.category2 === null;
    // const authorEmpty =
    //   !!this.state.searchInputData.author ||
    //   this.state.searchInputData.author === null;

    // const isValid =
    //   isInputValid ||
    //   isDateInput ||
    //   !category1Empty ||
    //   !category2Empty ||
    //   !authorEmpty;
    const isValid =
      isInputValid ||
      isDateInput ||
      category1Input ||
      category2Input ||
      authorInput;
    if (isValid) {
      this.setState({ isFormValid: true });
      this.submitSearch();
    } else {
      this.setState({ isFormValid: false });
    }
  };
  submitSearch = () => {
    const { currentPage, perPage, userId } = this.state;
    this.setState({
      isFavoriteLoader: true,
      isFavoriteFailed: false,
      isFormValid: true,
    });
    let order = this.state.order === "asc" ? true : false;
    var searchDetails;

    if (closeNewSearch) {
      searchDetails = {
        pageNumber: 1,
        pagesize: perPage,
        documentId: 0,
        documentName: null,
        documentNo: null,
        category1Id: 0,
        category1Name: null,
        category2Id: 0,
        category2Name: null,
        documentStatus: null,
        approvalStatus: null,
        fileId: 0,
        fileName: null,
        fileType: null,
        authorId: 0,
        authorName: null,
        fromDate: null,
        toDate: null,
        publishedDate: null,
        expiryDate: null,
        requestedDate: null,
      };
    } else {
      searchDetails = {
        pageNumber: 1,
        pagesize: parseInt(perPage),
        documentId: 0,
        documentName: this.state.searchInputData.docName
          ? this.state.searchInputData.docName
          : null,
        documentNo: this.state.searchInputData.docNo
          ? this.state.searchInputData.docNo
          : null,
        category1Id: this.state.searchInputData.category1?.value || 0,
        category1Name: this.state.searchInputData.category1?.label || null,
        category2Id: this.state.searchInputData.category2?.value || 0,
        category2Name: this.state.searchInputData.category2?.label || null,
        documentStatus: this.state.searchInputData.documentStatus || null,
        approvalStatus: this.state.searchInputData.approvalStatus || null,
        fileId: 0,
        fileName: this.state.searchInputData.fileName
          ? this.state.searchInputData.fileName
          : null,
        fileType: this.state.searchInputData.fileType
          ? this.state.searchInputData.fileType
          : null,
        authorId: this.state.searchInputData.author?.value || 0,
        authorName: this.state.searchInputData.author?.label || null,
        fromDate: null,
        toDate: null,
        publishedDate: this.state.searchInputData.expiryDate
          ? moment(this.state.searchInputData.expiryDate).format("YYYY-MM-DD")
          : null,
        expiryDate: null,
        requestedDate: null,
      };
    }
    let apiUrl = `${API.GET_ALL_FAVORITES}?userId=${this.state.userId}&sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: searchDetails,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.currentPage = 1;
          this.state.favouritesList = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.state.favouriteCount = res.data.totalCount;
          this.state.isFavoriteFailed = false;
          this.state.isFavoriteLoader = false;
          closeNewSearch = false;
          this.setState({}, () => {
            this.closeSearch();
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 400 || error.response.status === 500) {
          toast.error("Failed to search. Please try again", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
        }
        this.setState({ isFavoriteLoader: false, isFavoriteFailed: false });
        logoutFunction(error?.response?.status);
      });
  };

  getDocumentDetails = (item, fileDoc) => {
    this.setState({
      openDocument: item,
      openDocumentType: fileDoc,
    });
  };

  passwordValidationSuccess = () => {
    if (this.state.openDocumentType == "fileName") {
      this.handleFileOpen(
        this.state.openDocument?.fileId,
        this.state.openDocument?.fileType
      );
    } else {
      this.navigateDocuments(
        `/documents/${this.state.openDocument?.category1Id}/${this.state.openDocument?.category2Id}/${this.state.openDocument?.documentId}/`
      );
    }
  };

  passwordValidationFailed = () => {};

  render() {
    const {
      isFavoriteFailed,
      isFavoriteLoader,
      openauthorList,
      opencategory1List,
      opencategory2List,
      fileTypes,
      searchAuthorList,
      searchCategory1List,
      searchCategory2List,
      isFormValid,
      isMobile,
      isSmallMobile,
      isCancelMobile,
      favouriteCount,
      favouritePropertiesList,
      favouritesList,
      favouriteArryList,
      addcategoryValue,
      currentPage,
      isCategory2EditHide,
      isCategory2AddHide,
      isCategory2DeleteHide,
      perPage,
      editcategoryValue,
      isRadioMobile,
      currentUser,
      sortBy,
      order,
    } = this.state;
    let { classes, favoriteCommonSearchResult, menuToggle, category1List } =
      this.props;
    return (
      <>
        {$("#DetailsScreen").hasClass("show") ||
        $("#pendingSearchScreen").hasClass("show") ? (
          <div
            className="viewbar-overlay"
            onClick={() => this.ClearArrayList()}
          ></div>
        ) : (
          <></>
        )}
        <div
          className={`${
            isMobile
              ? "main-body-mobile"
              : menuToggle
              ? "menu-main-body"
              : "main-body"
          } `}
        >
          {isFavoriteLoader && (
            <div className="spinner_overlay">
              <div className="loader">
                <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
              </div>
            </div>
          )}

          {isFavoriteFailed && (
            <div className="spinner_overlay">
              <div className="loader">
                <span>Loading failed</span>
              </div>
            </div>
          )}
          {isMobile == true ? (
            <div className="head-fixed">
              <div className="mobile-head border-bottom w-100">
                <div className="col-12 mobile-title d-flex">
                  My favourites{" "}
                  <label className="rejectedstatus-color d-flex ms-1">
                    <span>(</span>
                    <span className="pending">{favouriteCount}</span>
                    <span>)</span>
                    {/* {"(" + <span className="mt-1 border border-danger">favouriteCount</span> + ")"} */}
                  </label>
                </div>
              </div>
              <div
                className={`${
                  isMobile ? "common-mobiletable-style" : "common-table-style"
                }`}
              >
                <div
                  className={`col-12 d-flex justify-content-start border-bottom table-responsive ${
                    isMobile ? "pl-1" : isSmallMobile ? "" : "pl-10"
                  } `}
                >
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="90%">
                          {favouriteArryList?.length !== 0 ? (
                            <>
                              <button
                                className={`displaybutton  ${
                                  isSmallMobile ? "pl-0" : ""
                                }`} //${isRadioMobile ? "pr-0" : "" }
                                id="displaybuttoncolor"
                                onClick={() => this.downloadMessage()}
                              >
                                <img
                                  src={DownloadIcon}
                                  style={{ marginTop: "-4px" }}
                                ></img>
                                <span
                                  className={`${
                                    isSmallMobile
                                      ? "subheadMobile-span"
                                      : "subhead-span"
                                  } p-2`}
                                >
                                  Download
                                </span>
                              </button>

                              <button
                                className={`displaybutton ${
                                  isRadioMobile ? "pr-0" : ""
                                }`}
                                id="displaybuttoncolor"
                                onClick={() => this.removeFavouriteMessage()}
                              >
                                <img
                                  src={RemoveFavoriteIcon}
                                  style={{ marginTop: "-4px" }}
                                ></img>
                                <span
                                  className={`${
                                    isSmallMobile
                                      ? "subheadMobile-span"
                                      : "subhead-span"
                                  } p-2`}
                                >
                                  {isRadioMobile
                                    ? "Remove"
                                    : "Remove favourites"}
                                </span>
                              </button>
                            </>
                          ) : (
                            <></>
                          )}
                          {favouriteArryList?.length === 1 ? (
                            <>
                              <button
                                className={`displaybutton ${
                                  isRadioMobile ? "pr-0" : ""
                                }`}
                                id="displaybuttoncolor"
                                onClick={() =>
                                  this.handleOpenFavouriteProperties()
                                }
                              >
                                <img
                                  src={PropertiesIcon}
                                  style={{ marginTop: "-4px" }}
                                ></img>
                                <span
                                  className={`${
                                    isSmallMobile
                                      ? "subheadMobile-span"
                                      : "subhead-span"
                                  } p-2`}
                                >
                                  Properties
                                </span>
                              </button>
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td width="10%" className="text-end">
                          <button
                            className={`displaybutton ${
                              isRadioMobile ? "pe-2" : ""
                            } ${isSmallMobile ? "pe-2" : ""} ${
                              isCancelMobile ? "pe-2" : ""
                            }`}
                            id="displaybuttoncolor"
                            onClick={() => this.OpenPendingSearch()}
                          >
                            <img
                              src={Filter}
                              style={{ marginTop: "-4px", marginRight: "8px" }}
                            ></img>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <div className="head-fixed">
              <div className="title">
                <img src={FavoriteIcon} />
                <span className="d-flex">
                  My favourites{" "}
                  <label className="rejectedstatus-color d-flex ms-1">
                    <span className="p-0">(</span>
                    <span className="pending p-0">{favouriteCount}</span>
                    <span className="p-0">)</span>
                  </label>
                </span>
              </div>
              <div
                className={`${
                  isMobile
                    ? "mobile-search"
                    : menuToggle
                    ? " sidemenu-search"
                    : "web-search"
                }`}
              >
                <table width="100%">
                  <tbody>
                    <tr>
                      <td width="90%">
                        {favouriteArryList?.length !== 0 ? (
                          <>
                            <button
                              className={`displaybutton ${
                                isRadioMobile ? "pr-0" : ""
                              } ${isSmallMobile ? "pl-0" : ""}`}
                              id="displaybuttoncolor"
                              onClick={() => this.downloadMessage()}
                            >
                              <img
                                src={DownloadIcon}
                                style={{ marginTop: "-4px" }}
                              ></img>
                              <span
                                className={`${
                                  isSmallMobile
                                    ? "subheadMobile-span"
                                    : "subhead-span"
                                } p-2`}
                              >
                                Download
                              </span>
                            </button>

                            <button
                              className={`displaybutton ${
                                isRadioMobile ? "pr-0" : ""
                              }`}
                              id="displaybuttoncolor"
                              onClick={() => this.removeFavouriteMessage()}
                            >
                              <img
                                src={RemoveFavoriteIcon}
                                style={{ marginTop: "-4px" }}
                              ></img>
                              <span
                                className={`${
                                  isSmallMobile
                                    ? "subheadMobile-span"
                                    : "subhead-span"
                                } p-2`}
                              >
                                {isRadioMobile ? "Remove" : "Remove favourites"}
                              </span>
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                        {favouriteArryList?.length === 1 ? (
                          <>
                            <button
                              className={`displaybutton ${
                                isRadioMobile ? "pr-0" : ""
                              }`}
                              id="displaybuttoncolor"
                              onClick={() =>
                                this.handleOpenFavouriteProperties()
                              }
                            >
                              <img
                                src={PropertiesIcon}
                                style={{ marginTop: "-4px" }}
                              ></img>
                              <span
                                className={`${
                                  isSmallMobile
                                    ? "subheadMobile-span"
                                    : "subhead-span"
                                } p-2`}
                              >
                                Properties
                              </span>
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                      </td>
                      <td width="10%" className="text-end">
                        <button
                          className={`displaybutton ${
                            isRadioMobile ? "pr-0" : ""
                          } ${isSmallMobile ? "pl-0" : ""}`}
                          id="displaybuttoncolor"
                          onClick={() => this.OpenPendingSearch()}
                        >
                          <img
                            src={Filter}
                            style={{ marginTop: "-4px", marginRight: "5px" }}
                          ></img>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <ToastContainer limit={1} />
          <div
            className={`${
              isMobile ? "pending-mobile-table " : "pending-table1 "
            }table-responsive  table-fixed-header table-responsive-height `}
            style={{ width: "100%" }}
            //style={{ width: "100%", height: "100%" }}
          >
            <table className="table fileListTable2 table-borderless table-hover">
              <thead className="thead-sticky  thead-color">
                <tr>
                  <td>
                    <input
                      type="checkbox"
                      name="request"
                      checked={
                        favouriteArryList?.length !== 0
                          ? favouriteArryList?.length === favouritesList?.length
                            ? true
                            : false
                          : false
                      }
                      onClick={() => this.handleCheckboxTop()}
                    />
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("documentNumber")}
                  >
                    <span>Document no.</span>
                    {sortBy === "documentNumber" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("documentName")}
                  >
                    <span>Document name</span>
                    {sortBy === "documentName" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("fileName")}
                  >
                    <span>File name</span>
                    {sortBy === "fileName" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("authorName")}
                  >
                    <span>Author</span>
                    {sortBy === "authorName" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("category1Name")}
                  >
                    <span>Category 1</span>{" "}
                    {sortBy === "category1Name" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("category2Name")}
                  >
                    <span>Category 2 </span>
                    {sortBy === "category2Name" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  {UserRole.ADMIN === currentUser ? (
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("status")}
                    >
                      <span> Status</span>{" "}
                      {sortBy === "status" && (
                        <img
                          src={order === "asc" ? upArrow : downArrow}
                          alt=""
                        />
                      )}
                    </td>
                  ) : (
                    <></>
                  )}
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("publishedDate")}
                  >
                    <span>Published date/time </span>
                    {sortBy === "publishedDate" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {favouritesList?.length !== 0 ? (
                  favouritesList?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor:
                          favouriteArryList?.filter((r) => r == item.id)
                            ?.length > 0
                            ? "#f3f2f1"
                            : "",
                        cursor: "pointer",
                      }}
                      onDoubleClick={() =>
                        this.handleChangeChecked(
                          item.id,
                          item.fileId,
                          item.documentId
                        )
                      }
                    >
                      <td>
                        <input
                          type="checkbox"
                          name="request"
                          checked={
                            favouriteArryList?.filter((r) => r == item.id)
                              ?.length > 0
                              ? true
                              : false
                          }
                          onClick={() =>
                            this.handleCheckbox(
                              item.id,
                              item.fileId,
                              item.documentId
                            )
                          }
                        />
                      </td>
                      <td>
                        <span>
                          <a
                            className="properties-view tableoverflowNo"
                            title={item.documentNumber}
                            // onClick={() => this.getDocumentDetails(item, "documentNo")}
                            data-bs-toggle={
                              item.isPasswordProtected == true && "modal"
                            }
                            data-bs-target={
                              item.isPasswordProtected == true &&
                              "#passwordLoginModal"
                            }
                            onClick={
                              item.isPasswordProtected == false
                                ? () =>
                                    this.navigateDocuments(
                                      `/documents/${item.category1Id}/${item.category2Id}/${item.documentId}/`
                                    )
                                : () =>
                                    this.getDocumentDetails(item, "documentNo")
                            }
                          >
                            {item.documentNumber}
                          </a>
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflowNo"
                          title={item.documentName}
                        >
                          {item.documentName}
                        </span>
                      </td>
                      <td className="d-flex">
                        {/* className="d-flex cell-padding" */}
                        {item.fileType === "url" ? (
                          <img src={url} alt="" />
                        ) : (
                          <FileIcon fileName={item.fileName} />
                        )}
                        <span
                          className="pl-11 text-center tablefilename"
                          title={item.fileName}
                          data-bs-toggle={
                            item.isPasswordProtected == true && "modal"
                          }
                          data-bs-target={
                            item.isPasswordProtected == true &&
                            "#passwordLoginModal"
                          }
                          // onClick={() => this.getDocumentDetails(item,  "fileName")}
                          onClick={
                            item.isPasswordProtected == false
                              ? () =>
                                  this.handleFileOpen(
                                    item.fileId,
                                    item.fileType
                                  )
                              : () => this.getDocumentDetails(item, "fileName")
                          }
                          // onClick={() =>
                          //   this.handleFileOpen(item.fileId, item.fileType)
                          // }
                        >
                          {item.fileName}
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflow1"
                          title={item.authorName}
                        >
                          {item.authorName}{" "}
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflow1"
                          title={item.category1Name}
                        >
                          {item.category1Name}
                        </span>
                      </td>
                      <td>
                        <span
                          className="tableoverflow1"
                          title={item.category2Name}
                        >
                          {item.category2Name}
                        </span>
                      </td>
                      {UserRole.ADMIN === currentUser ? (
                        <td
                          className={` fw-600 ${
                            item.status === "Published"
                              ? "activestatus-color"
                              : item.status === "Obsolete"
                              ? "rejectedstatus-color"
                              : "favorite-20days"
                          }`}
                        >
                          <span className="tableoverflow1" title={item.status}>
                            {item.status}
                          </span>
                        </td>
                      ) : (
                        <></>
                      )}
                      <td>
                        {" "}
                        <span className="tableoverflowDate">
                          {item.publishedDate
                            ? moment(
                                new Date(Date.parse(item.publishedDate))
                              ).format("DD-MMM-YYYY h:mm A")
                            : ""}
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    {UserRole.ADMIN === currentUser ? (
                      <td colSpan={9} className="table-nodata">
                        {favouritesList && "No record found"}
                      </td>
                    ) : (
                      <td colSpan={8} className="table-nodata">
                        {favouritesList && "No record found"}
                      </td>
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div
            className={`${
              isMobile
                ? "common-mobilesubmenu mobile-pagination"
                : menuToggle
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
            } pb-2 pt-2`}
          >
            {favouritesList?.length !== 0 ? (
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="8%" className="p-3">
                      <div style={{ minWidth: "80px", maxWidth: "80px" }}>
                        <Select
                          options={paginglist}
                          defaultValue={paginglistDefault}
                          classNamePrefix="paging"
                          isSearchable={false}
                          menuPlacement={"top"}
                          menuPosition={"fixed"}
                          onChange={(e) => this.find(e)}
                        />
                      </div>
                    </td>
                    <td
                      width="92%"
                      className={`text-end ${
                        this.state.isCancelMobile ? "pagination-padd" : "p-3"
                      }`}
                    >
                      {this.state.isMobile ? (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={1}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      ) : (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={3}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : null}
          </div>
        </div>

        {/* Common search */}
        <div
          className="offcanvas offcanvas-end offcanvaspendingStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="pendingSearchScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title">
              Search
            </h6>
            <button
              className={`text-reset offcavasclose  buttonstyle ${
                isMobile ? "pr-0" : "pr-0"
              }`}
              data-bs-dismiss="offcanvas"
              id="closeSearchButton"
              onClick={() => this.closeSearch()}
              style={{ backgroundColor: "white" }}
            >
              <img src={CrossIcon} className="cursor-pointer app-image-hover" />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 pt-0" id="viewbar8">
            <div className="row">
              <div className="col-sm-6 col-12 d-flex flex-column mt-2 mb-2">
                <div className="inputTitle commonsearch-field">
                  <span>
                    <img
                      style={{ position: "relative", top: "-1px" }}
                      src={infoBlack}
                      alt=""
                    />{" "}
                    Document no.
                  </span>
                </div>
                <input
                  style={{ fontSize: "12px" }}
                  value={this.state.searchInputData.docNo}
                  onChange={(e) => this.handleChange(e, "docNo")}
                  maxLength={255}
                  className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                  required
                />
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle commonsearch-field">
                  <img src={file} alt="" />
                  <span> Document name</span>
                </div>
                <input
                  style={{ fontSize: "12px" }}
                  value={this.state.searchInputData.docName}
                  onChange={(e) => this.handleChange(e, "docName")}
                  maxLength={255}
                  className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                  required
                />
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="">
                  <div className="inputTitle m-2 mt-0 ms-0 commonsearch-field">
                    <img src={SubCategoryIcon} alt="" />
                    <span> Category 1</span>
                  </div>
                  <Select
                    className="text-12-normal"
                    classNamePrefix="assigngroups"
                    value={this.state.searchInputData.category1}
                    options={searchCategory1List}
                    defaultValue={
                      this.state.searchInputData.category1 || "Select"
                    }
                    isMulti={false}
                    isSearchable={true}
                    isClearable={true}
                    onChange={(e) =>
                      this.handleSearchSelectChange(e, "category1")
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="">
                  <div className="inputTitle m-2 mt-0 ms-0 commonsearch-field">
                    <img src={SubCategoryIcon} alt="" />
                    <span> Category 2</span>
                  </div>
                  <Select
                    className="text-12-normal"
                    classNamePrefix="assigngroups"
                    value={this.state.searchInputData.category2}
                    options={searchCategory2List}
                    isDisabled={!this.state.searchInputData.category1}
                    defaultValue={
                      this.state.searchInputData.category2 || "Select"
                    }
                    isMulti={false}
                    isSearchable={true}
                    isClearable={true}
                    onChange={(e) =>
                      this.handleSearchSelectChange(e, "category2")
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle commonsearch-field">
                  <img src={file} alt="" />
                  <span> File name</span>
                </div>
                <input
                  style={{ fontSize: "12px" }}
                  value={this.state.searchInputData.fileName}
                  onChange={(e) => this.handleChange(e, "fileName")}
                  className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                  maxLength={255}
                  required
                />
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle commonsearch-field">
                  <img src={file} alt="" />
                  <span> File type</span>
                </div>
                <select
                  value={this.state.searchInputData.fileType}
                  onChange={(e) => this.handleChange(e, "fileType")}
                  className="form-control  my-input-class border-radius shiptype-select mt-2 dropdown-height"
                  required
                >
                  <option value="">Select</option>
                  {fileTypes?.map((option) => (
                    <option
                      key={option.filetypeName}
                      value={option.filetypeName}
                    >
                      {option.filetypeName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="">
                  <div className="inputTitle mb-2 commonsearch-field">
                    <img src={SubCategoryIcon} alt="" />
                    <span> Author</span>
                  </div>
                  <Select
                    className="text-12-normal"
                    classNamePrefix="assigngroups"
                    value={this.state.searchInputData.author}
                    options={searchAuthorList}
                    defaultValue={this.state.searchInputData.author || "Select"}
                    isMulti={false}
                    isSearchable={true}
                    isClearable={true}
                    onChange={(e) => this.handleSearchSelectChange(e, "author")}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-12 mt-2 mb-2">
                <div className="inputTitle commonsearch-field">
                  <img src={infoBlack} alt="" />
                  <span>Status</span>
                </div>
                <input
                  style={{ fontSize: "12px",height:"34.5px" }}
                  value={this.state.searchInputData.documentStatus}
                  onChange={(e) => this.handleChange(e, "documentStatus")}
                  maxLength={255}
                  className="form-control my-input-class border-radius shiptype-select mt-2"
                  required
                />
              </div>
              <div
                className="col-sm-6 col-12 mt-2 mb-2"
                style={{ marginTop: "12px" }}
              >
                <div className="inputTitle date-bottom commonsearch-field">
                  <img src={calender} alt="" />
                  <span>Published date </span>
                </div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    className="form-control f-12 mt-1 date-dropdown-height"
                    emptyLabel="dd-mmm-yyyy"
                    keyboardIcon={<img src={dateIcon} />}
                    format="dd-MMM-yyyy"
                    value={
                      this.state.searchInputData.expiryDate
                        ? this.state.searchInputData.expiryDate
                        : null
                    }
                    size="small"
                    onChange={(e) => this.handleChange(e, "expiryDate")}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>

            {!isFormValid && (
              <p style={{ color: "red" }}>At least one field is mandatory</p>
            )}

            <div className="button" style={{ display: "flex" }}>
              <button id="edit2" onClick={() => this.clearSearch()}>
                <span className="clear-icon-position">✕</span>
                <span>Clear</span>
              </button>
              <button id="edit" onClick={() => this.validatesubmitSearch()}>
                <img
                  style={{
                    marginTop: "-4px",
                    marginRight: "4px",
                    width: "14px",
                  }}
                  src={search}
                  alt=""
                />
                Search
              </button>
            </div>
          </div>
        </div>

        <div
          className="offcanvas offcanvas-end offcanvasStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="DetailsScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title head-span">
              {favouritePropertiesList.documentNo}
            </h6>
            <button
              className={`text-reset offcavasclose  buttonstyle ${
                isMobile ? "pr-0" : ""
              }`}
              onClick={() => this.ClearArrayList()}
              style={{ backgroundColor: "white" }}
            >
              <img src={CrossIcon} className="cursor-pointer app-image-hover" />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 pt-0" id="viewbar">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={NewPropertiesIcon} />{" "}
                    <span className="pl-10 properties-span">Document no.</span>
                    &nbsp;
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                    title={favouritePropertiesList.documentNo}
                  >
                    {favouritePropertiesList.documentNo
                      ? favouritePropertiesList.documentNo
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={SearchFileIcon} />{" "}
                    <span className="pl-10 properties-span mt-1">
                      Document name
                    </span>
                    &nbsp;
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                    title={favouritePropertiesList.documentName}
                  >
                    {favouritePropertiesList.documentName
                      ? favouritePropertiesList.documentName
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={AssignIcon} />{" "}
                    <span className="pl-10 properties-span">Author</span>
                  </label>
                  <label
                    className={`properties-label  Propertiestext-overflow${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                    title={favouritePropertiesList.authorName}
                  >
                    {favouritePropertiesList.authorName
                      ? favouritePropertiesList.authorName
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={NewPropertiesIcon} />{" "}
                    <span className="pl-10 properties-span">Version</span>&nbsp;
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                    title={favouritePropertiesList.version}
                  >
                    {favouritePropertiesList.version
                      ? favouritePropertiesList.version
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={SubCategoryIcon} />{" "}
                    <span className="pl-10 properties-span">Category 1</span>
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                    title={favouritePropertiesList.category1Name}
                  >
                    {favouritePropertiesList.category1Name
                      ? favouritePropertiesList.category1Name
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={SubCategoryIcon} />{" "}
                    <span className="pl-10 properties-span">Category 2</span>
                  </label>
                  <label
                    className={`properties-label Propertiestext-overflow ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                    title={favouritePropertiesList.category2Name}
                  >
                    {favouritePropertiesList.category2Name
                      ? favouritePropertiesList.category2Name
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={DateIcon} />{" "}
                    <span className="pl-10 properties-span">
                      Published date
                    </span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {favouritePropertiesList.publishedDate
                      ? moment(favouritePropertiesList.publishedDate).format(
                          "DD-MMM-YYYY"
                        )
                      : " - "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-3"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={DateIcon} />{" "}
                    <span className="pl-10 properties-span">Expiry date</span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {favouritePropertiesList.reviewDate
                      ? moment(favouritePropertiesList.reviewDate).format(
                          "DD-MMM-YYYY"
                        )
                      : " - "}
                  </label>
                </div>
              </div>
              {UserRole.ADMIN === currentUser ? (
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                    isMobile ? "" : "pb-3"
                  } `}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <img className="properties-img" src={NewPropertiesIcon} />{" "}
                      <span className="pl-10 properties-span">Status</span>
                    </label>
                    <label
                      className={`properties-label Propertiestext-overflow ${
                        favouritePropertiesList?.approvalStatus
                          ?.toLowerCase()
                          .includes("published")
                          ? "activestatus-color"
                          : favouritePropertiesList?.approvalStatus
                              ?.toLowerCase()
                              ?.includes("obsolete")
                          ? "rejectedstatus-color"
                          : "favorite-20days"
                      }
                       ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}
                      title={favouritePropertiesList.approvalStatus}
                    >
                      {favouritePropertiesList.approvalStatus
                        ? favouritePropertiesList.approvalStatus
                        : " - "}
                    </label>
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${
                  isMobile ? "" : "pb-3"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={NotesIcon} />{" "}
                    <span className="pl-10 properties-span mt-1">Notes</span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {favouritePropertiesList.remarks
                      ? favouritePropertiesList.remarks
                      : " - "}
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <img className="properties-img" src={VersionIcon} />{" "}
                    <span className="pl-10 properties-span">Versions</span>
                  </label>
                  <div className="table-responsive mb-4 mt-3">
                    <table id="versionTable" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th
                            className={`${isSmallMobile ? "Author-width" : ""}`}
                          >
                            Versions
                          </th>
                          <th
                            className={`${isSmallMobile ? "Author-width" : ""}`}
                          >
                            Author
                          </th>
                          <th
                            className={`${
                              isSmallMobile ? "Publisheddate-width" : ""
                            } no-wrap`}
                          >
                            Published date/time
                          </th>
                          <th
                            className={`${isSmallMobile ? "Author-width" : ""}`}
                          >
                            Checker
                          </th>
                          <th
                            className={`${isSmallMobile ? "Author-width" : ""}`}
                          >
                            Approver
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.versionLogList?.length !== 0 ? (
                          this.state.versionLogList?.map((i, index) => (
                            <>
                              <tr id={index}>
                                <td className="no-wrap">{i.documentVersion}</td>
                                <td className="no-wrap">{i.author}</td>
                                <td className="no-wrap">
                                  {i.publishedDate
                                    ? moment(
                                        new Date(Date.parse(i.publishedDate))
                                      ).format("DD-MMM-YYYY h:mm A")
                                    : ""}
                                </td>
                                <td className="no-wrap">{i.checkerName}</td>
                                <td className="no-wrap">{i.approverName}</td>
                              </tr>
                              <tr></tr>
                            </>
                          ))
                        ) : (
                          <tr>
                            <td className="table-noversion" colSpan={5}>
                              No version history
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PasswordLoginModal
          item={this.state.openDocument}
          passwordValidated={() => this.passwordValidationSuccess()}
          passwordFailed={() => this.passwordValidationFailed()}
          moduleName="favourites"
        />
        {this.state.isPlayVideo && (
          <VideoPop
            videoUrl={this.state.videoSrc}
            onClose={() => this.handleCloseModal()}
          />
        )}

        {this.state.isPlayAudio && (
          <AudioPopup
            audioUrl={this.state.audioSrc}
            onClose={() => this.handleCloseModal()}
          />
        )}
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    favoriteCommonSearchResult: state.commonReducer.favoriteCommonSearchResult,
    menuToggle: state.commonReducer.menuToggle,
    sideMenu: state.commonReducer.sideMenu,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Favourites)
);
